export default {
  state: {
    google: null,
    map: null,
    homeMarker: null
  },

  mutations: {
    setGoogle(state, payload) {
      state.google = payload;
    },
    setMap(state, payload) {
      state.map = payload;
    },
    setHomeMarker(state, payload) {
      state.homeMarker = payload;
    }
  },

  actions: {
    setGoogle({ commit }, google) {
      commit("setGoogle", google);
    },
    setMap({ commit }, map) {
      commit("setMap", map);
    },
    setHomeMarker({ commit }, marker) {
      commit("setHomeMarker", marker);
    }
  },

  getters: {
    getGoogle(state) {
      return state.google;
    },
    getMap(state) {
      return state.map;
    },
    getHomeMarker(state) {
      return state.homeMarker;
    }
  }
};
